import React, {useContext} from "react";
import { useTranslation } from "react-i18next";
import DateFormated from "../../../Utils/Date/Date";
import UserContext from "../../../../context/user-context";

const Header = (props) => {
    const { t, i18n } = useTranslation();
	const {subAccountAddress, invoiceNumber, netAmount, balanceAmount, transactionStatus, dueDate, transactionDateTime, purchaseOrderNumber} = props.invoice

	let name = '';
	if (props.invoice.invoiceAccount) {
		name = props.invoice.invoiceAccount.name;
	} else if (props.invoice.subAccountName) {
		name = props.invoice.subAccountName
	}

	const address = subAccountAddress
		? `${subAccountAddress.addressLine1}${
			subAccountAddress.addressLine2
				? `, ${subAccountAddress.addressLine2}`
				: ""
		}, ${subAccountAddress.city},
			${subAccountAddress.stateOrProvinceCode
          }, ${subAccountAddress.postalCode}`
		: '';

    return(
        <div className="invoice-review-modal__header section-separator">
            <h2 className="h2">
                {t('invoice_review.header.title')}
            </h2>

            <div className="invoice-review-modal__header__top row flex--align-center p p--ff--accent">
                <div className="col-12 col-lg-8 py-5 px-4">
                    <h3><strong>{name}</strong></h3>
                    <address>{address}</address>
                </div>

                <div className="col-12 col-lg-4 flex flex--direction-column a-right flex--gap--1">
                    <strong>
                        {t('invoice_review.header.invoice_number')}
                        <span className="span span--c-green">
                            {invoiceNumber}
                        </span>
                    </strong>
                    <span>
                        {t('invoice_review.header.netAmount')}
                        {netAmount.formattedUnitValue}
                    </span>

                    <span>
                        {t('invoice_review.header.balance_amount')}
                        {balanceAmount.formattedUnitValue}
                    </span>

                    <span>
                        {t('invoice_review.header.transaction_status')}
                        {i18n.language === "fr"
                            ? transactionStatus.descriptionFr
                            : transactionStatus.descriptionEn
                        }
                    </span>
                </div>
            </div>
            <div className="invoice-review-modal__header__bottom row p">
                <div className="col-12 col-lg-6 flex flex--direction-column">
                    <i>
                        {t('invoice_review.header.due_date')}
                        <DateFormated date={dueDate} withTime={false} />
                    </i>
                    <i>
                        {t('invoice_review.header.transaction_date_time')}
                        <DateFormated date={transactionDateTime} withTime={false} />
                    </i>
                </div>

                {purchaseOrderNumber &&
                    <div className="col-12 col-lg-6">
                        {t('invoice_review.header.po')}
                        {purchaseOrderNumber}
                    </div>
                }
            </div>
        </div>
    );
}

export default Header;
